// All recipe data for Knorr Recipe Builder
import images from './images';

const recipe = {
  "recipes": [
    {
      "title": "Molten Lava Kabab",
      "description": "These crispy potato kebabs hide a secret center of fiery sauce that melts into a flavor volcano the moment you take a bite.",
      "servings": "8",
      "cookingTime": "25 mins",
      "difficulty": "Medium",
      "ingredients": [
        {
          "category": "Kabab Mixture",
          "items": [
            {
              "name": "Potato (Boiled)",
              "quantity": "250g"
            },
            {
              "name": "Carrot (Brunoised)",
              "quantity": "50g"
            },
            {
              "name": "Capsicum (Brunoised)",
              "quantity": "50g"
            },
            {
              "name": "Cabbbage (Brunoised)",
              "quantity": "50g"
            },
            {
              "name": "Knorr Chattpatta Masala",
              "quantity": "10g"
            },
            {
              "name": "Knorr Chicken Cube",
              "quantity": "1"
            },
            {
              "name": "Green Chilli (Sliced)",
              "quantity": "5"
            },
            {
              "name": "Green Coriander",
              "quantity": "5"
            }
          ]
        },
        {
          "category": "Lava Filling",
          "items": [
            {
              "name": "Knorr Ketchup",
              "quantity": "50g"
            },
            {
              "name": "Knorr Chilli Garlic  Sauce",
              "quantity": "25g"
            },
            {
              "name": "Gelatin",
              "quantity": "15g"
            }
          ]
        },
        {
          "category": "Coating",
          "items": [
            {
              "name": "All Purpose Flour",
              "quantity": "As needed"
            },
            {
              "name": "Knorr Chicken Powder",
              "quantity": "3g"
            },
            {
              "name": "Egg (Beaten)",
              "quantity": "1"
            },
            {
              "name": "Bread Crumbs",
              "quantity": "As needed"
            },
            {
              "name": "Oil (Frying)",
              "quantity": "As needed"
            }
          ]
        }
      ],
      "cookingSteps": [
        {
          "step": "Step 1: Prep",
          "instructions": [
            "Mix Base: Combine Kebab Ingredients and divide into 50 gm balls.",
            "Make Lava Core: Simmer Knorr Tomato Ketchup & Knorr Chilli Garlic Sauce. Dissolve gelatin into the sauce mixture, and spread to set in a silicon mould."
          ]
        },
        {
          "step": "Step 2: Assemble",
          "instructions": [
            "Stuffing: Roll the set sauce into small balls and stuff one into each potato ball."
          ]
        },
        {
          "step": "Step 3: Cook & Serve",
          "instructions": [
            "Dredge: Coat balls in egg, then in the mixture of Knorr Chicken Powder & Flour, and finally in bread crumbs.",
            "Finish: Deep fry until golden brown. Serve hot."
          ]
        }
      ],
      "imageLink": images.lavaKebab
    },
    {
      "title": "Dumpling Dahi Baray",
      "description": "Juicy, hand-crafted chicken dumplings steamed to perfection and served on a bed of yogurt packed with Knorr Green Chutney and crunchy sev.",
      "servings": "2-3",
      "cookingTime": "30 mins",
      "difficulty": "Medium",
      "ingredients": [
        {
          "category": "Dumpling Wrapper",
          "items": [
            {
              "name": "All Purpose Flour",
              "quantity": "250 Gm"
            },
            {
              "name": "Salt",
              "quantity": "3 Gm"
            },
            {
              "name": "Vinegar",
              "quantity": "3 Ml"
            },
            {
              "name": "Water (Luke Warm)",
              "quantity": "100 Ml"
            }
          ]
        },
        {
          "category": "Dumpling Filling",
          "items": [
            {
              "name": "Chicken (Mince)",
              "quantity": "100 Gm"
            },
            {
              "name": "Knorr Chicken Cube",
              "quantity": "1 Pcs"
            },
            {
              "name": "Carrot (Brunoised)",
              "quantity": "25 Gm"
            },
            {
              "name": "Ginger (Fine Chopped)",
              "quantity": "10 Gm"
            },
            {
              "name": "Green Onion",
              "quantity": "25 Gm"
            },
            {
              "name": "Soy Sauce",
              "quantity": "15 Ml"
            },
            {
              "name": "Oyster Sauce",
              "quantity": "10 Ml"
            },
            {
              "name": "Sesame Oil",
              "quantity": "5 Ml"
            },
            {
              "name": "Corn Flour",
              "quantity": "10 Gm"
            },
            {
              "name": "Salt",
              "quantity": "3 Gm"
            }
          ]
        },
        {
          "category": "Yogurt & Garnish",
          "items": [
            {
              "name": "Yogurt",
              "quantity": "250 Gm"
            },
            {
              "name": "Knorr Chattpatta Masala",
              "quantity": "3 Gm"
            },
            {
              "name": "Knorr Green Chutney",
              "quantity": "10 Ml"
            },
            {
              "name": "Knorr Chili Garlic Sauce",
              "quantity": "10 Ml"
            },
            {
              "name": "Tamarind Sauce",
              "quantity": "10 Ml"
            },
            {
              "name": "Pomegranate Seeds",
              "quantity": "30 Gm"
            },
            {
              "name": "Sev",
              "quantity": "10 Gm"
            }
          ]
        }
      ],
      "cookingSteps": [
        {
          "step": "Step 1: Prep",
          "instructions": [
            "Dough: Knead Flour, Salt, Vinegar, and Water into a dough; rest for 30 mins.",
            "Stuffing: Dissolve Knorr Chicken Cube in warm water and mix with all other stuffing Ingredients."
          ]
        },
        {
          "step": "Step 2: Shape  & Cook",
          "instructions": [
            "Form Dumplings: Divide dough into 10 gm balls. Roll into thin sheets, add stuffing, and shape into dumplings.",
            "Cook: Place dumplings in a steamer and steam for 15 mins."
          ]
        },
        {
          "step": "Step 3: Assemble & Serve",
          "instructions": [
            "Set Base: Whisk Yogurt and pour into a dish.",
            "Serve: Arrange dumplings on top and sprinkle with Pomegranate, Sev, Knorr Green Chutney and Knorr Chilli Garlic Sauce."
          ]
        }
      ],
      "imageLink": images.dumplings
    },
    {
      "title": "Croissant Lasagna",
      "description": "Lasagna gets a buttery, French-inspired makeover! Ditch the pasta for layers of crisp croissant slices, savory spiced mince, and Knorr Pizza Pasta Sauce for a decadent, cheesy masterpiece.",
      "servings": "3-4",
      "cookingTime": "30 mins",
      "difficulty": "Low",
      "ingredients": [
        {
          "category": "Mince Filling",
          "items": [
            {
              "name": "Chicken Or Beef Mince",
              "quantity": "200 Grams"
            },
            {
              "name": "Onions Chopped 1 Medium",
              "quantity": "4 Tbsp"
            },
            {
              "name": "Garlic Chopped",
              "quantity": "1 Tbsp"
            },
            {
              "name": "Mushrooms Chopped",
              "quantity": "3 Pcs"
            },
            {
              "name": "Capsicum In Small Cubes 1 Medium",
              "quantity": "2 Tbsp"
            }
          ]
        },
        {
          "category": "Mustard Paste ½ Tsp",
          "items": [
            {
              "name": "Knorr Chicken Powder",
              "quantity": "1 Tsp"
            },
            {
              "name": "Paprika Powder",
              "quantity": "1 Tsp"
            }
          ]
        },
        {
          "category": "Chili Flakes ½ Tsp",
          "items": [
            {
              "name": "Knorr Chili Garlic Sauce",
              "quantity": "2 Tbsp"
            }
          ]
        },
        {
          "category": "Knorr Pizza Pasta Sauce ¼ Cup",
          "items": [
            {
              "name": "Dried Mixed Herbs",
              "quantity": "1 Tsp"
            },
            {
              "name": "Cooking Oil",
              "quantity": "4 Tbsp"
            },
            {
              "name": "Butter",
              "quantity": "1 Tbsp"
            }
          ]
        },
        {
          "category": "Creamy Sauce",
          "items": [
            {
              "name": "Un-Sweetened Cream",
              "quantity": "1 Cup"
            }
          ]
        },
        {
          "category": "Milk ½ Cup",
          "items": [
            {
              "name": "Knorr Chicken Powder",
              "quantity": "1 Tsp"
            },
            {
              "name": "Mustard Paste",
              "quantity": "1 Tsp"
            },
            {
              "name": "Black Pepper Powder",
              "quantity": "1 Tsp"
            },
            {
              "name": "Mixed Herbs",
              "quantity": "1 Tsp"
            },
            {
              "name": "Garlic Powder",
              "quantity": "1 Tsp"
            },
            {
              "name": "Onion Powder",
              "quantity": "1 Tsp"
            }
          ]
        },
        {
          "category": "Mozzarella Cheese ½ Cup",
          "items": [
            {
              "name": "Croissant 2 Pcs Sliced",
              "quantity": ""
            }
          ]
        }
      ],
      "cookingSteps": [
        {
          "step": "Step 1: Prep the Mince",
          "instructions": [
            "Sauté: Heat Oil and Butter; sauté Garlic and Onions.",
            "Cook: Brown Mince with Spices for 7–8 mins.",
            "Add the Magic: Stir in Vegetables, Knorr Pizza Pasta Sauce, and Knorr Chilli Garlic Sauce."
          ]
        },
        {
          "step": "Step 2: Make the Creamy Sauce",
          "instructions": [
            "Whisk: Combine cream, milk, and the other spices in a pan.",
            "Simmer: Add Knorr Chicken Powder and simmer for 5 mins; remove from heat."
          ]
        },
        {
          "step": "Step 3: Assemble",
          "instructions": [
            "Base: Line a container with croissant slices and top with the mince filling.",
            "Middle: Add 1/4 cup Mozzarella and the creamy sauce.",
            "Top: Finish with a final layer of croissant slices and 1/4 cup more cheese."
          ]
        },
        {
          "step": "Step 4: Bake",
          "instructions": [
            "Finish: Bake at 180°C for 20 mins, then grill the top for 5 mins until golden."
          ]
        }
      ],
      "imageLink": images.lasagna
    },
    {
      "title": "Deconstructed Palak Patta Chaat",
      "description": "Experience the crunch of golden-fried spinach leaves layered with zesty mashed chickpeas and a refreshing swirl of yogurt and vibrant chutneys. ",
      "servings": "8",
      "cookingTime": "25 mins",
      "difficulty": "Low",
      "ingredients": [
        {
          "category": "Potato-Spinach Base",
          "items": [
            {
              "name": "Spinach (Blanched)",
              "quantity": "150 Gm"
            },
            {
              "name": "Potato (Boiled)",
              "quantity": "250 Gm"
            },
            {
              "name": "Knorr Green Chutney",
              "quantity": "50 Gm"
            },
            {
              "name": "Knorr Chattpatta Masala",
              "quantity": "15 Gm"
            }
          ]
        },
        {
          "category": "Chickpea Layer",
          "items": [
            {
              "name": "Chickpeas (Boiled)",
              "quantity": "250 Gm"
            },
            {
              "name": "Knorr Ketchup",
              "quantity": "50 Gm"
            }
          ]
        },
        {
          "category": "Fried Spinach",
          "items": [
            {
              "name": "Spinach",
              "quantity": "50 Gm"
            },
            {
              "name": "Gram Flour",
              "quantity": "50 Gm"
            },
            {
              "name": "Oil (Frying)",
              "quantity": "As needed"
            }
          ]
        },
        {
          "category": "Yogurt & Seasoning",
          "items": [
            {
              "name": "Yogurt",
              "quantity": "150 Gm"
            },
            {
              "name": "Knorr Chicken Powder",
              "quantity": "3 Gm"
            },
            {
              "name": "Knorr Chattpatta Masala",
              "quantity": "10 Gm"
            }
          ]
        }
      ],
      "cookingSteps": [
        {
          "step": "Step 1: Prep the Layers",
          "instructions": [
            "Potato-Spinach Base: Blend blanched Spinach into a paste; mix with Potato, Knorr Green Chutney, and Knorr Chattpatta Masla.",
            "Chickpea Layer: Mash Chickpeas and mix with Knorr Tomato Ketchup.",
            "Yogurt Sauces: Prepare green and red yogurt Sauces by adding Green Chutney and Kniorr Chilli Garlic Sauce to 2 separate batches of yogurt. Season with Knorr Chattpatta Masala.",
            "Crispy Leaves: Coat Fresh Spinach in a thick Gram Flour batter and deep fry until crisp."
          ]
        },
        {
          "step": "Step 2: Assemble & Serve",
          "instructions": [
            "Base: Set the Potato Base in a dish and sprinkle with Chattpatta Masala.",
            "Middle: Add a layer of Chickpeas (Channa) followed by the Yogurt Sauces.",
            "Top: Garnish with fresh Vegetables and the Fried Palak crisps."
          ]
        }
      ],
      "imageLink": images.palak
    },
    {
      "title": "Swicy Chicken Tenders 2 Ways \n(Korean and Hot Honey Tenders)",
      "description": "A symphony of crunch and flavor! These ultra-crispy tenders are marinated for maximum juiciness and served with two addictive glazes: a spicy-sweet Hot Honey and a glossy, savory Korean-style glaze.",
      "servings": "6-8",
      "cookingTime": "20 mins",
      "difficulty": "Low",
      "ingredients": [
        {
          "category": "Chicken & Marinade",
          "items": [
            {
              "name": "500g Boneless Chicken Breast Strips Or Tenders",
              "quantity": ""
            }
          ]
        },
        {
          "category": "½ Cup Plain Yogurt",
          "items": [
            {
              "name": "2 Tbsp Knorr Thai Sweet Chilli Sauce",
              "quantity": ""
            },
            {
              "name": "1 Tbsp Knorr Chicken Powder",
              "quantity": ""
            }
          ]
        },
        {
          "category": "½ Tsp Paprika",
          "items": [
            {
              "name": "1 Tsp Onion Powder",
              "quantity": ""
            },
            {
              "name": "1 Tsp Garlic Powder",
              "quantity": ""
            }
          ]
        },
        {
          "category": "Dry Coating",
          "items": [
            {
              "name": "1 Cup All-Purpose Flour",
              "quantity": ""
            }
          ]
        },
        {
          "category": "½ Cup Cornflour",
          "items": [
            {
              "name": "1 Tsp Paprika",
              "quantity": ""
            },
            {
              "name": "1 Tsp Garlic Powder",
              "quantity": ""
            },
            {
              "name": "1 Tsp Knorr Chicken Powder",
              "quantity": ""
            }
          ]
        },
        {
          "category": "½ Cup Knorr Thai Sweet Chilli Sauce",
          "items": [
            {
              "name": "25g Butter",
              "quantity": ""
            },
            {
              "name": "1 Tsp Crushed Garlic",
              "quantity": ""
            },
            {
              "name": "1 Tsp Paprika",
              "quantity": ""
            }
          ]
        },
        {
          "category": "½ Cup Knorr Chilli Garlic Sauce",
          "items": [
            {
              "name": "2 Tbsp Knorr Pizza & Pasta Sauce",
              "quantity": ""
            },
            {
              "name": "3 Tbsp Granulated Brown Sugar",
              "quantity": ""
            },
            {
              "name": "1 Tsp Paprika Powder",
              "quantity": ""
            },
            {
              "name": "3 Tbsp Soy Sauce",
              "quantity": ""
            },
            {
              "name": "2 Tsp Vinegar",
              "quantity": ""
            },
            {
              "name": "2 Tbsp Water",
              "quantity": ""
            },
            {
              "name": "1 Tbsp Sesame Oil",
              "quantity": ""
            },
            {
              "name": "2 Tsp Crushed Ginger",
              "quantity": ""
            },
            {
              "name": "2 Tsp Crushed Garlic",
              "quantity": ""
            }
          ]
        }
      ],
      "cookingSteps": [
        {
          "step": "Step 1: Prep",
          "instructions": [
            "Marinate: Mix Marinade ingredients. Coat Chicken and rest for 20–30 mins.",
            "Coating: Combine all Dry Coating ingredients in a separate bowl."
          ]
        },
        {
          "step": "Step 2: Make the Glazes",
          "instructions": [
            "Hot Honey Glaze: Stir ingredients in a pan over low heat until Butter melts and bubbles.",
            "Korean Glaze: Simmer ingredients in a pan for 2 mins until glossy and thick."
          ]
        },
        {
          "step": "Step 3: Fry the Chicken",
          "instructions": [
            "Dredge: Coat chicken in dry coating ingredients; shake off excess.",
            "Fry in Oil until golden and crispy. Drain on a wire rack."
          ]
        },
        {
          "step": "Step 4: Finish and Serve",
          "instructions": [
            "Reheat glazes.",
            "Toss chicken directly in the sauces or serve them on the side."
          ]
        }
      ],
      "imageLink": images.tenders
    },
    {
      "title": "Spicy Shakshuka with Mini Paratha Croissants",
      "description": "Juicy tomatoes and Knorr Pizza Pasta Sauce meet perfectly poached eggs, served alongside golden, flaky croissantsmade out of frozen parathas for when you're craving something hearty.",
      "servings": "2",
      "cookingTime": "30 mins ",
      "difficulty": "Medium",
      "ingredients": [
        {
          "category": "Spicy Shakshuka",
          "items": [
            {
              "name": "Tomato Chopped (Approx 1 Medium)",
              "quantity": "2 Tbsp"
            }
          ]
        },
        {
          "category": "Knorr Pizza Pasta Sauce ¼ Cup",
          "items": [
            {
              "name": "Knorr Chili Garlic Sauce",
              "quantity": "1 Tbsp"
            },
            {
              "name": "Onion Chopped",
              "quantity": "1 Tbsp"
            },
            {
              "name": "Capsicum Chopped",
              "quantity": "1 Tbsp"
            },
            {
              "name": "Garlic Chopped",
              "quantity": "1 Tsp"
            }
          ]
        },
        {
          "category": "Black Pepper Powder ¼ Tsp",
          "items": [
            {
              "name": "Oil",
              "quantity": "2 Tbsp"
            },
            {
              "name": "Eggs",
              "quantity": "3"
            },
            {
              "name": "Fresh Dill Leaves (Garnish Optional)",
              "quantity": "1 Tsp"
            }
          ]
        },
        {
          "category": "Mini Paratha Croissants",
          "items": [
            {
              "name": "Frozen Paratha",
              "quantity": "2 Pcs"
            },
            {
              "name": "Egg Wash",
              "quantity": "1"
            },
            {
              "name": "Sesame Seeds (Garnish On Top)",
              "quantity": "1 Tsp"
            }
          ]
        }
      ],
      "cookingSteps": [
        {
          "step": "Step 1: Prep the Croissants",
          "instructions": [
            "Shape: Cut defrosted Paratha into long triangles. Stretch slightly and roll from the wide end into a croissant shape.",
            "Bake: Brush with Egg Wash, sprinkle with Sesame Seeds, and bake at 180°C for 18–20 mins."
          ]
        },
        {
          "step": "Step 2: Sauté the Base",
          "instructions": [
            "Soften Aromatics: Heat Oil; sauté Garlic and Onion for 5 mins until soft.",
            "Simmer Sauce: Stir in Tomatoes, Knorr Pizza Pasta Sauce, Knorr Chilli Garlic Sauce, and other spices.",
            "Simmer for 5–7 mins until thickened."
          ]
        },
        {
          "step": "Step 3: Cook the Eggs",
          "instructions": [
            "Add Eggs: Stir in Capsicum. Make small wells in the sauce and gently crack an Egg into each.",
            "Cook: Cover and cook on low-medium for 5 mins until eggs are set but soft."
          ]
        },
        {
          "step": "Step 4: Finish",
          "instructions": [
            "Garnish with Dill or Parsley.",
            "Serve hot alongside the paratha croissants."
          ]
        }
      ],
      "imageLink": images.shakshuka
    },
    {
      "title": "Marry Me Chicken Pasta",
      "description": "A spectacular, crowd-pleasing feast! Succulent chicken steaks are seared to golden perfection and bathed in a luxurious, creamy sun-dried tomato sauce infused with Knorr’s savory depth. This velvety pasta dish is so rich and flavorful that it has earned its reputation as a definitive favorite for special occasions.",
      "servings": "4",
      "cookingTime": "20 mins",
      "difficulty": "Low",
      "ingredients": [
        {
          "category": "Chicken & Seasoning",
          "items": [
            {
              "name": "4 Chicken Steaks (Approx. 600–650 G)",
              "quantity": ""
            },
            {
              "name": "2 Tsp Garlic Powder",
              "quantity": ""
            },
            {
              "name": "2 Tsp Paprika",
              "quantity": ""
            },
            {
              "name": "1 Tsp Oregano",
              "quantity": ""
            }
          ]
        },
        {
          "category": "½ Tsp Salt",
          "items": [
            {
              "name": "1 Tsp Freshly Cracked Black Pepper",
              "quantity": ""
            },
            {
              "name": "3–4 Tbsp Oil",
              "quantity": ""
            }
          ]
        },
        {
          "category": "The Creamy Sauce",
          "items": [
            {
              "name": "1 Knorr Chicken Cube",
              "quantity": ""
            },
            {
              "name": "500 Ml Water",
              "quantity": ""
            },
            {
              "name": "200 Ml Dairy Cream",
              "quantity": ""
            },
            {
              "name": "250 Ml Milk",
              "quantity": ""
            },
            {
              "name": "2 Medium Onions, Finely Diced",
              "quantity": ""
            },
            {
              "name": "5–6 Garlic Cloves, Crushed",
              "quantity": ""
            },
            {
              "name": "3 Tbsp Knorr Pizza & Pasta Sauce",
              "quantity": ""
            },
            {
              "name": "60–70g Sun-Dried Tomatoes, Sliced Or Chopped",
              "quantity": ""
            }
          ]
        },
        {
          "category": "A Handful Of Baby Spinach (Or Chopped Regular Spinach / Basil Leaves)",
          "items": [
            {
              "name": "70g Parmesan, Shredded",
              "quantity": ""
            }
          ]
        },
        {
          "category": "Pasta & Garnish",
          "items": [
            {
              "name": "250g Uncooked Pasta Of Your Choice",
              "quantity": ""
            }
          ]
        }
      ],
      "cookingSteps": [
        {
          "step": "Step 1: Prep the Components",
          "instructions": [
            "Slit Chicken Steaks, rub with spices listed, and rest for 15 mins.",
            "Dissolve 1 Knorr Chicken Cube in 500mL Water.",
            "In another bowl, whisk Milk into Cream."
          ]
        },
        {
          "step": "Step 2: Sear the Chicken & Aromatics",
          "instructions": [
            "Sear chicken in Oil for 3 mins per side until golden; remove and set aside.",
            "In the same pan, sauté Onions until translucent, then add Garlic for 1 min."
          ]
        },
        {
          "step": "Step 3: Build the Sauce",
          "instructions": [
            "Stir Knorr Pizza Pasta Sauce and Sun-Dried Tomatoes into the garlic-onion mixture and cook for 1 min.",
            "Add Stock, Cream Mixture, Salt, Spinach, and Parmesan. Bring to a simmer."
          ]
        },
        {
          "step": "Step 4: Combine and Serve",
          "instructions": [
            "Return chicken to pan; simmer on low for 5–7 mins.",
            "Serve: Toss in cooked Pasta for 1 min. Garnish with Tomatoes, Basil, and Pepper."
          ]
        }
      ],
      "imageLink": images.pasta
    }
  ],
  "totalRecipes": 7
};

export default recipe;